var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        { staticClass: "tongji_option" },
        [
          _c(
            "span",
            { staticClass: "tongji" },
            [
              _c("van-cell", {
                attrs: { title: "统计时间", value: _vm.date },
                on: { click: _vm.onOpen }
              }),
              _c("img", {
                attrs: { src: require("../../../static/images/down.png") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { on: { click: _vm.changeRange } }, [
            _vm._v("统计课程"),
            !_vm.range
              ? _c("img", {
                  attrs: { src: require("../../../static/images/down.png") }
                })
              : _c("img", {
                  attrs: { src: require("../../../static/images/up.png") }
                })
          ]),
          _vm._v(" "),
          _c("van-calendar", {
            ref: "calendar",
            attrs: {
              title: "请选择日期",
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate,
              type: "range",
              position: "top",
              "show-mark": false,
              color: "#e60012"
            },
            on: {
              confirm: _vm.onConfirms,
              close: _vm.onClose,
              select: _vm.onSelect
            },
            model: {
              value: _vm.timepick,
              callback: function($$v) {
                _vm.timepick = $$v
              },
              expression: "timepick"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.range
        ? _c(
            "div",
            { staticClass: "check_options" },
            [
              _vm._l(_vm.packlist, function(i, index) {
                return _c("p", { key: index, staticClass: "choose_option" }, [
                  _c("span", { staticClass: "radio-name" }, [
                    _vm._v(_vm._s(i.value))
                  ]),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "radio-circle",
                    class: { "radio-check": i.check },
                    attrs: { for: "radio" + index }
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: i.check,
                        expression: "i.check"
                      }
                    ],
                    attrs: { id: "radio" + index, type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(i.check)
                        ? _vm._i(i.check, null) > -1
                        : i.check
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = i.check,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && _vm.$set(i, "check", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  i,
                                  "check",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(i, "check", $$c)
                          }
                        },
                        function($event) {
                          return _vm.pack(i.id)
                        }
                      ]
                    }
                  })
                ])
              }),
              _vm._v(" "),
              _c("p", { staticClass: "screen_btn" }, [
                _c("span", { on: { click: _vm.changereset } }, [
                  _vm._v("重置")
                ]),
                _c(
                  "span",
                  { staticClass: "determine", on: { click: _vm.onsure } },
                  [_vm._v("确定")]
                )
              ])
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.data
      ? _c("div", { staticClass: "report-wrapper" }, [
          _c("div", { staticClass: "info_detail" }, [
            _c("div", { staticClass: "statistics" }, [
              _c("div", [
                _c("p", [
                  _c("span", [_vm._v("学习总时长")]),
                  _c("span", { staticClass: "learn_num" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.data.course_total.current_study_duration_total
                        )
                      )
                    ]),
                    _vm._v("小时")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total_time" }, [
                    _vm._v(
                      "累计时长" +
                        _vm._s(_vm.data.course_total.study_duration_total) +
                        "小时"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "borders" }),
              _vm._v(" "),
              _c("div", [
                _c("p", [
                  _c("span", [_vm._v("学习总天数")]),
                  _c("span", { staticClass: "learn_num" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.data.course_total.current_study_day_total)
                      )
                    ]),
                    _vm._v("天")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total_time" }, [
                    _vm._v(
                      "累计天数" +
                        _vm._s(_vm.data.course_total.study_day_total) +
                        "天"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "borders" }),
              _vm._v(" "),
              _c("div", [
                _c("p", [
                  _c("span", [_vm._v("课件完成数")]),
                  _c("span", { staticClass: "learn_num" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.data.course_total.current_course_finish_total
                        )
                      )
                    ]),
                    _vm._v("个")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total_time" }, [
                    _vm._v(
                      "累计完成" +
                        _vm._s(_vm.data.course_total.course_finish_total) +
                        "个"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.data.live.effective_attendance.total != 0
            ? _c("div", { staticClass: "live_detail" }, [
                _c("p", { staticClass: "live_title" }, [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: { src: require("../../../static/images/live.png") }
                    }),
                    _vm._v("直播\n          "),
                    _c("span", { staticClass: "supplementary" }, [
                      _vm._v(
                        "周期内共" +
                          _vm._s(_vm.data.live.attendance.total) +
                          "节直播,出勤" +
                          _vm._s(_vm.data.live.attendance.attendance) +
                          "节"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.data.live.attendance.total != 0
                    ? _c(
                        "span",
                        {
                          staticClass: "godetail",
                          on: { click: _vm.goToLive }
                        },
                        [
                          _vm._v("详情"),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/images/detail.png")
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "partition_statistics" }, [
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("课程完成数")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(
                        _vm._s(_vm.data.live.attendance.current_attendance) +
                          "/" +
                          _vm._s(_vm.data.live.attendance.current_total)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计完成" +
                          _vm._s(
                            _vm.data.live.effective_attendance
                              .effective_attendance
                          ) +
                          "/" +
                          _vm._s(_vm.data.live.effective_attendance.total)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("直播观看时长")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(
                        _vm._s(_vm.data.live.effective_watch.effective_watch)
                      ),
                      _c("span", { staticClass: "hours" }, [_vm._v("小时")])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计时长" +
                          _vm._s(_vm.data.live.effective_watch.total) +
                          "时"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("回放净观看时长")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(_vm._s(_vm.data.playback.current_duration)),
                      _c("span", { staticClass: "hours" }, [_vm._v("小时")])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计时长" + _vm._s(_vm.data.playback.duration) + "时"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data.video.grand_total != 0
            ? _c("div", { staticClass: "video_detail" }, [
                _c("p", { staticClass: "live_title" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "godetail", on: { click: _vm.goVideo } },
                    [
                      _vm._v("详情"),
                      _c("img", {
                        attrs: {
                          src: require("../../../static/images/detail.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "partition_statistics" }, [
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", { staticClass: "cumulative_duration" }, [
                      _vm._v("完成数")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(
                        _vm._s(_vm.data.video.current_finish_total) +
                          "/" +
                          _vm._s(_vm.data.video.current_grand_total)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计完成" +
                          _vm._s(_vm.data.video.finish_total) +
                          "/" +
                          _vm._s(_vm.data.video.grand_total)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", { staticClass: "cumulative_duration" }, [
                      _vm._v("观看时长")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(_vm._s(_vm.data.video.current_duration)),
                      _c("span", { staticClass: "hours" }, [_vm._v("小时")])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计时长" + _vm._s(_vm.data.video.duration) + "小时"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "canvas",
                    staticStyle: { opacity: "0" }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data.homework.grand_total != 0
            ? _c("div", { staticClass: "homework_detail" }, [
                _c("p", { staticClass: "live_title" }, [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/homework.png")
                      }
                    }),
                    _vm._v("作业"),
                    _vm.ua
                      ? _c("span", { staticClass: "supplementary" }, [
                          _vm._v("可登录学习APP及时处理未完成作业")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isApp
                    ? _c(
                        "span",
                        {
                          staticClass: "godetail",
                          on: { click: _vm.goHomeWork }
                        },
                        [
                          _vm._v("详情"),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/images/detail.png")
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "partition_statistics" }, [
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("完成数")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(
                        _vm._s(_vm.data.homework.current_finish_total) +
                          "/" +
                          _vm._s(_vm.data.homework.current_grand_total)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计完成" +
                          _vm._s(_vm.data.homework.finish_total) +
                          "/" +
                          _vm._s(_vm.data.homework.grand_total)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("正确率")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(_vm._s(_vm.data.homework.current_rate))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("历史正确率" + _vm._s(_vm.data.homework.rate))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("平均分")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(_vm._s(_vm.data.homework.current_avg)),
                      _c("span", { staticClass: "hours" }, [_vm._v("分")])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("历史平均分" + _vm._s(_vm.data.homework.avg))
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data.simulate.grand_total != 0
            ? _c("div", { staticClass: "mock_detail" }, [
                _c("p", { staticClass: "live_title" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm.isApp
                    ? _c(
                        "span",
                        { staticClass: "godetail", on: { click: _vm.goMock } },
                        [
                          _vm._v("详情"),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/images/detail.png")
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "partition_statistics" }, [
                  _c("div", { staticClass: "canvas" }, [
                    _c("p", [_vm._v("完成数")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "finish_num" }, [
                      _vm._v(
                        _vm._s(_vm.data.simulate.finish) +
                          "/" +
                          _vm._s(_vm.data.simulate.finish_total)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "累计完成" +
                          _vm._s(_vm.data.simulate.grand_finish) +
                          "/" +
                          _vm._s(_vm.data.simulate.grand_total)
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "introduce" }, [
      _c("span"),
      _vm._v("课程完成：直播观看达45分钟或回放观看达50%")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("../../../static/images/shipin.png") }
      }),
      _vm._v("视频")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../../../static/images/mock.png") } }),
      _vm._v("模考")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e4eef8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4eef8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/reportscreen.vue
// module id = null
// module chunks = 